import type {
  AcuityApproversResponse,
  AcuityHistoryResponse,
  AcuityResolutionPayload,
  AcuityResolutionResponse,
  PostAcuityScoreResponse,
  UUID,
  PostAcuityScorePayload,
  ReasoningOptionsResponse,
  CurrentAcuityScoreResponse,
} from "@/core/types";
import type { ApiContext } from "@/api/types";
import { getGroupAuthType } from "@/utils/authToken";
import { GROUP_AUTH_HEADER_NAME } from "@/api/constants";
import { httpAuth2 } from "@/api/auth";

export const acuityRequestsTyped = {
  get_acuity_history: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: UUID;
  }): Promise<AcuityHistoryResponse> {
    return httpAuth2
      .get(`/v1/acuity_score/patient/${patientId}/history`, {
        context: { preventAllErrorToast: true, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<AcuityHistoryResponse>();
  },

  get_approvers: function ({
    context,
  }: { context?: ApiContext } = {}): Promise<AcuityApproversResponse> {
    return httpAuth2
      .get("/v1/acuity_score/approvers", {
        context: { preventAllErrorToast: true, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<AcuityApproversResponse>();
  },

  get_current_acuity_score: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: UUID;
  }): Promise<CurrentAcuityScoreResponse> {
    return httpAuth2
      .get(`/v1/acuity_score/patient/${patientId}/current`, {
        context: { preventAllErrorToast: true, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<CurrentAcuityScoreResponse>();
  },

  get_reasoning_options: function ({
    context,
  }: { context?: ApiContext } = {}): Promise<ReasoningOptionsResponse> {
    return httpAuth2
      .get("/v1/acuity_score/reasoning_options", {
        context: { preventAllErrorToast: true, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<ReasoningOptionsResponse>();
  },

  post_acuity_resolution: function ({
    context,
    data,
    patientId,
  }: {
    context?: ApiContext;
    data: AcuityResolutionPayload;
    patientId: UUID;
  }): Promise<AcuityResolutionResponse> {
    return httpAuth2
      .post(`/v1/acuity_score/patient/${patientId}/resolution`, {
        context: { preventAllErrorToast: true, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json<AcuityResolutionResponse>();
  },

  post_acuity_score: function ({
    context,
    data,
    patientId,
  }: {
    context?: ApiContext;
    data: PostAcuityScorePayload;
    patientId: UUID;
  }): Promise<PostAcuityScoreResponse> {
    return httpAuth2
      .post(`/v1/acuity_score/patient/${patientId}/request`, {
        context: { preventAllErrorToast: true, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json<PostAcuityScoreResponse>();
  },
};
